import i18n from '@/utils/i18n';
import React from 'react';
import { Chip, Icons } from '@usepepper/sprout-kit-ui';
import {
  DateTimeSelection,
  formatDateTimeSelection,
} from '@/experiences/sales-portal/blocs/utils/date-picker-calendar-utils';

interface ActivityNoteReminderPillProps {
  isOpen?: boolean;
  onPress: () => void;
  reminder?: DateTimeSelection;
}

export const ActivityNoteReminderPill: React.FC<
  ActivityNoteReminderPillProps
> = ({ isOpen, onPress, reminder }) => {
  const reminderLabel = reminder
    ? formatDateTimeSelection(reminder)
    : i18n.t('sales_portal.activity_note.reminder.set_reminder');

  return (
    <Chip
      circular
      onPress={onPress}
      pressable
      selected={isOpen || !!reminder}
      size="$md"
    >
      <Chip.Icon>
        <Icons.Bell />
      </Chip.Icon>
      <Chip.Text>{reminderLabel}</Chip.Text>
    </Chip>
  );
};
